import { useEffect, useState } from "react";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useAppDispatch } from "../../../../../app/redux/hooks";
import { getFaqAsync } from "../../../../../app/slices/footerSlice/footerSlice";

export const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ResponsiveAppBar />
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <div className="tf-page-title style-3">
          <div className="container-full">
            <div className="heading text-center">Terms & Conditions</div>
          </div>
        </div>
        <section className="flat-spacing-9">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <img
                  src="images/policy.png"
                  width="500"
                  style={{ float: "left" }}
                  className="me-5 mb-5 img-fluid"
                  alt=""
                />

                <p className="mb-3">
                  "Your privacy matters to us. This policy explains how we
                  collect, use, store, and protect your personal data, and
                  outlines your rights in regard to the personal information we
                  process."
                </p>
                <p className="mb-3">
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                </p>
                <p className="mb-3">
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                </p>
                <p className="mb-3">
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                </p>
                <p className="mb-3">
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                </p>
                <p className="mb-3">
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored.
                  Explain that user data is encrypted and securely stored. Your
                  privacy matters to us. This policy explains how we collect,
                  use, store, and protect your personal data, and outlines your
                  rights in regard to the personal information we process. Your
                  privacy matters to us. This policy explains how we collect,
                  use, store, and protect your personal data, and outlines your
                  rights in regard to the personal information we process.
                </p>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
